
import { M5_UNIT_1 } from './Unit1';
import { M5_UNIT_2 } from './Unit2';  
import { M5_UNIT_3 } from './Unit3';
import { M5_UNIT_4 } from './Unit4';
import { M5_UNIT_5 } from './Unit5';  
import { M5_UNIT_6 } from './Unit6';
import { M5_UNIT_7 } from './Unit7';
import { M5_UNIT_8 } from './Unit8';
import { M5_UNIT_9 } from './Unit9';
import { M5_UNIT_10 } from './Unit10';
import { M5_UNIT_11 } from './Unit11';
import { M5_UNIT_12 } from './Unit12';
import { M5_UNIT_13 } from './Unit13';
import { M5_UNIT_14 } from './Unit14';
import { M5_READING_PRACTICE } from './ReadingPractice';
import { M5_MODULE_REVIEW } from './UnitReview';

export const MODULE_5_UNITS = [
  M5_UNIT_1,
  M5_UNIT_2,
  M5_UNIT_3,
  M5_UNIT_4,
  M5_UNIT_5,
  M5_UNIT_6,
  M5_UNIT_7,
  M5_UNIT_8,
  M5_UNIT_9,
  M5_UNIT_10,
  M5_UNIT_11,
  M5_UNIT_12,
  M5_UNIT_13,
  M5_UNIT_14,
  M5_READING_PRACTICE,
  M5_MODULE_REVIEW
 
];